var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24 1.342c.239-.737 1.281-.737 1.52 0l.857 2.633a.8.8 0 0 0 .76.553h2.77c.774 0 1.096.992.47 1.447l-2.24 1.628a.8.8 0 0 0-.291.894l.855 2.633c.24.737-.604 1.35-1.23.895l-2.24-1.628a.8.8 0 0 0-.941 0l-2.24 1.628c-.627.455-1.47-.158-1.231-.895l.855-2.633a.8.8 0 0 0-.29-.894L.384 5.975c-.628-.455-.305-1.447.47-1.447h2.769a.8.8 0 0 0 .76-.553z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.7ddda1a9d4e65eadd9e0f833196e7c9a.svg";
export { ForwardRef as ReactComponent };